// auth.js
export const LOGIN = 'Logged the user in';
export const LOGIN_FAILURE = 'Login failed';
export const LOGOUT = 'Logged the user out';
export const SAVE_TOKEN = 'Saved user\'s token';
export const FETCH_USER = 'Fetched user';
export const FETCH_USER_SUCCESS = 'Fetched the user successfully';
export const FETCH_USER_FAILURE = 'Failed to fetch the user';
export const UPDATE_USER = 'Updated user';
export const SET_API_ACCESS_TOKEN = 'Setting API Access Token';
export const SET_ORIGINAL_DESTINATION = 'Setting original destination';

// action.js
export const RESET_ACTION = 'Reset action';
export const FETCHING_ACTION = 'Fetching action';
export const FETCH_ACTION_SUCCESS = 'Fetched action successfully';
export const FETCH_ACTION_FAILURE = 'Failed to fetched action';

export const UPDATING_ACTION = 'Updating action';
export const UPDATE_ACTION_SUCCESS = 'Updated action successfully';
export const UPDATE_ACTION_FAILURE = 'Failed to update action';

export const TOGGLE_ACTION_SEARCH = 'Search actions toggled';
export const TOGGLE_PROPERTY_SEARCH = 'Search properties toggled';
export const TOGGLE_JOB_SEARCH = 'Search jobs toggled';
export const TOGGLE_JOB_REQUEST_SEARCH = 'Search job requests toggled';

export const SET_COMPLIANCE_TYPE = 'Set compliance type';

export const SET_PROPERTY_TENURE = 'Set property tenure';

export const SET_DUE_DATE_TYPE = 'Set due date type';

// counts.js
export const RESET_COUNTS = 'Reset counts';
export const FETCHING_COUNTS = 'Fetching counts';
export const FETCH_COUNTS_SUCCESS = 'Fetched counts successfully';
export const FETCH_COUNTS_FAILURE = 'Failed to fetch counts';
export const FRA_DUE_DATES = 'FRA due dates';
export const WORKPLAN_DUE_DATES = 'Work plan dates';

// clientActionCounts.js
export const RESET_CLIENT_ACTION_COUNTS = 'Reset client action counts';
export const FETCHING_CLIENT_ACTION_COUNTS = 'Fetching client action counts';
export const FETCH_CLIENT_ACTION_COUNTS_SUCCESS = 'Fetched client action counts successfully';
export const FETCH_CLIENT_ACTION_COUNTS_FAILURE = 'Failed to fetch client action counts';

// propertyCounts.js
export const RESET_PROPERTY_COUNTS = 'Reset property counts';
export const FETCHING_PROPERTY_COUNTS = 'Fetching property counts';
export const FETCH_PROPERTY_COUNTS_SUCCESS = 'Fetched property counts successfully';
export const FETCH_PROPERTY_COUNTS_FAILURE = 'Failed to fetch property counts';

// tags.js
export const RESET_TAGS = 'Reset tags';
export const FETCHING_TAGS = 'Fetching tags';
export const FETCH_TAGS_SUCCESS = 'Fetched tags successfully';
export const FETCH_TAGS_FAILURE = 'Failed to fetched tags';

// gridOptions.js
export const SAVING_GRID_OPTIONS = 'Saving grid options';
export const SAVE_GRID_OPTIONS_SUCCESS = 'Saved grid options successfully';
export const SAVE_GRID_OPTIONS_FAILURE = 'Failed to save grid options';

export const FETCHING_GRID_OPTIONS = 'Fetching grid options';
export const FETCH_GRID_OPTIONS_SUCCESS = 'Fetched grid options successfully';
export const FETCH_GRID_OPTIONS_FAILURE = 'Failed to fetch grid options';
export const RESET_GRID_OPTIONS = 'Reset grid options';


// grids.js
export const REFRESHING_ACTION_GRID = 'Refreshing actions';
export const REFRESHING_ACTION_GRID_COMPLETE = 'Refresh actions complete';

export const SETTING_ACTION_STATUS_FILTER = 'Setting actions status filter';

export const SETTING_ACTION_ACTIONS_MENU_VISIBLE = 'Actions menu toggled';

export const SET_DUE_DATE_BY = 'Set due date by';
